import { Component, Input, OnChanges } from '@angular/core';
import { Mission } from '@shared/entities/mission';
import { ChartConfiguration, ChartDataset, ChartOptions } from 'chart.js';
import { format } from 'date-fns';

@Component({
  selector: 'app-icam-chart',
  templateUrl: './icam-chart.component.html',
  styleUrl: './icam-chart.component.scss'
})
export class IcamChartComponent implements OnChanges {
  @Input() machinePerformanceDetails: Mission[] = [];
  @Input() selectedFilterName: string | null = null;
  lineChartData!: ChartConfiguration<'line'>['data'];
  maxPickingMissions = 0;
  maxRefillingMissions = 0;
  pickingColor = 'rgb(0, 168, 234)';
  private _pickingBgColor = 'rgba(0, 168, 234, 0.07)';
  refillingColor = 'rgb(242, 143, 6)';
  private _refillingBgColor = 'rgba(242, 143, 6, 0.07)';
  private _aggregation: 'DAY' | 'MONTH' = 'DAY';

  private _chartConfig = [
    {
      label: 'MISSIONI DI PICKING',
      fill: true,
      tension: 0,
      borderColor: this.pickingColor,
      backgroundColor: this._pickingBgColor,
      pointBorderColor: this.pickingColor,
      pointBackgroundColor: 'white',
      borderWidth: 1.5,
      data: []
    },
    {
      label: 'MISSIONI DI REFILLING',
      fill: true,
      tension: 0,
      borderColor: this.refillingColor,
      backgroundColor: this._refillingBgColor,
      pointBorderColor: this.refillingColor,
      pointBackgroundColor: 'white',
      borderWidth: 1.5,
      data: []
    }
  ];

  lineChartOptions: ChartOptions<'line'> = {
    responsive: true,
    maintainAspectRatio: false
  };

  constructor() {
    /* noop */
  }

  ngOnChanges() {
    if (this.machinePerformanceDetails) {
      this.lineChartData = this._createChartConfiguration();
    }
  }

  private _createChartConfiguration(): ChartConfiguration<'line'>['data'] {
    const datasets: ChartDataset<'line'>[] = [];

    const labels: string[] = [];
    const pickings: number[] = [];
    const refillings: number[] = [];

    this.machinePerformanceDetails.forEach((data) => {
      if (data.period) {
        labels.push(this._aggregation === 'DAY' ? format(data.period, 'dd/MM') : format(data.period, 'MM/yyyy'));
      }
      pickings.push(data.pickingMissions || 0);
      refillings.push(data.refillingMissions || 0);
    });

    this.maxPickingMissions = Math.max(...pickings);
    this.maxRefillingMissions = Math.max(...refillings);

    datasets.push({ ...this._chartConfig[0], data: pickings });
    datasets.push({ ...this._chartConfig[1], data: refillings });

    const obj = { labels, datasets };

    return obj;
  }
}
